import { Component, ViewChild } from '@angular/core';
import { ToastMessageOptions } from 'primeng/api';
import { TranslateModule } from '@ngx-translate/core';
import { CalloutComponent } from '../callout/callout.component';
import { Toast, ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  imports: [ToastModule, CalloutComponent, TranslateModule],
})
export class ToastComponent {
  @ViewChild('toast') private toast: Toast | undefined;

  public onClose(message: ToastMessageOptions) {
    if (this.toast?.messages && this.toast.messages.length > 0) {
      const messageIndex = this.toast.messages.findIndex(entry => entry.id === message.id);
      if (messageIndex !== -1) {
        this.toast.messages?.splice(messageIndex, 1);
      }
    }
  }
}
